import * as React from 'react'
import MUITabs from '@mui/material/Tabs'

const Tabs = (props) => <MUITabs {...props} />

export default Tabs
